module.exports = __webpack_public_path__ + "img/laurier.8afbbc16.png";